angular.module 'app'
.controller 'NewSmgRecordModal', ($scope, $http, $stateParams, $uibModalInstance, $timeout, $rootScope, config, dialogs, Storage, growl) ->

  $scope.ui =
    records: []
    currentPage: 1
    perPage: 10
    maxSize: 5
    totalItems: 0
    date: ''
    opts: config.opts
    type: 'specialweather'

  # 設置日曆
  $scope.ui.opts.parentEl = 'div#material-graphic'
  $scope.ui.opts.opens = 'right'
  
  fetchData = ->
    _start_created_at = ''
    _end_created_at = ''

    if $scope.ui.date.startDate is null or $scope.ui.date.endDate is null or String(new Date($scope.ui.date.startDate)) is 'Invalid Date' or String(new Date($scope.ui.date.endDate)) is 'Invalid Date'
      _start_created_at = ''
      _end_created_at = ''
    else
      _start_created_at = moment($scope.ui.date.startDate).format('YYYY-MM-DD 00:00:00')
      _end_created_at = moment($scope.ui.date.endDate).format('YYYY-MM-DD 23:59:59')

    $http.get "#{config.api.baseUrl}/#{$stateParams.original_id}/follower/smg/records?access_token=" + Storage.get('access_token'),
      params:
        limit: $scope.ui.perPage
        offset: ($scope.ui.currentPage - 1) * $scope.ui.perPage
        start_created_at: _start_created_at
        end_created_at: _end_created_at
    .then (res) ->
      _.each res.data.data, (val) ->
        val.createTime = moment(val.created_at).format('YYYY-MM-DD')
        total_count = _.findWhere val.records, key: 'total'
        val.total_count = total_count.count
        TyphoonWarning = _.findWhere val.records, key: 'TyphoonWarning'
        val.TyphoonWarning = TyphoonWarning.count
        Stormsurge = _.findWhere val.records, key: 'Stormsurge'
        val.Stormsurge = Stormsurge.count
        RainstormWarning = _.findWhere val.records, key: 'RainstormWarning'
        val.RainstormWarning = RainstormWarning.count
        ThunderstormWarning = _.findWhere val.records, key: 'ThunderstormWarning'
        val.ThunderstormWarning = ThunderstormWarning.count
        MonsoonWarning = _.findWhere val.records, key: 'MonsoonWarning'
        val.MonsoonWarning = MonsoonWarning.count
        TsunamiWarning = _.findWhere val.records, key: 'TsunamiWarning'
        val.TsunamiWarning = TsunamiWarning.count
        SpecialInfo1 = _.findWhere val.records, key: 'SpecialInfo1'
        val.SpecialInfo1 = SpecialInfo1.count
        SpecialInfo2 = _.findWhere val.records, key: 'SpecialInfo2'
        val.SpecialInfo2 = SpecialInfo2.count
        SpecialInfo3 = _.findWhere val.records, key: 'SpecialInfo3'
        val.SpecialInfo3 = SpecialInfo3.count
        SpecialInfo4 = _.findWhere val.records, key: 'SpecialInfo4'
        val.SpecialInfo4 = SpecialInfo4.count
        SpecialInfo7 = _.findWhere val.records, key: 'SpecialInfo7'
        val.SpecialInfo7 = SpecialInfo7.count
        SpecialInfo8 = _.findWhere val.records, key: 'SpecialInfo8'
        val.SpecialInfo8 = SpecialInfo8.count
        SpecialInfo9 = _.findWhere val.records, key: 'SpecialInfo9'
        val.SpecialInfo9 = SpecialInfo9.count
        TempAlert = _.findWhere val.records, key: 'TempAlert'
        val.TempAlert = TempAlert.count
        InfoAlert = _.findWhere val.records, key: 'InfoAlert'
        val.InfoAlert = InfoAlert.count
      $scope.ui.totalItems = res.data.count
      $scope.ui.records = res.data.data
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  $scope.$watch 'ui.currentPage', fetchData

  $scope.searchText = ->
    $scope.ui.totalItems = 0
    $scope.ui.records = []
    $scope.ui.currentPage = 1
    fetchData()

  # 下載資料
  prepare = (url) ->
    dialogs.wait '請稍後', '正在努力下載...', $scope.progress
    fakeProgress()

  success = (url) ->
    $rootScope.$broadcast 'dialogs.wait.complete'

  error = (response, url) ->
    dialogs.error '下載失敗!'

  fakeProgress = ->
    $timeout (->
      if $scope.progress < 95
        $scope.progress += (96 - ($scope.progress)) / 2
        $rootScope.$broadcast 'dialogs.wait.progress', 'progress': $scope.progress
        fakeProgress()
      else
        $rootScope.$broadcast 'dialogs.wait.complete'
    ), 100

  $scope.progress = 0
  $scope.exportRecords = ->
    $scope.progress = 0

    if $scope.ui.date.startDate is null or $scope.ui.date.endDate is null or String(new Date($scope.ui.date.startDate)) is 'Invalid Date' or String(new Date($scope.ui.date.endDate)) is 'Invalid Date'
      _start_created_at = ''
      _end_created_at = ''
    else
      _start_created_at = moment($scope.ui.date.startDate).format('YYYY-MM-DD 00:00:00')
      _end_created_at = moment($scope.ui.date.endDate).format('YYYY-MM-DD 23:59:59')

    _params =
      start_created_at: _start_created_at
      end_created_at: _end_created_at

    $.fileDownload "#{config.api.baseUrl}/#{$stateParams.original_id}/follower/smg/new-export/?access_token=" + Storage.get('access_token'),
      httpMethod: 'POST'
      data: _params
      prepareCallback: prepare
      successCallback: success
      failCallback: error

  $scope.cancel = ->
    $uibModalInstance.close 'Cancel'